<div *ngIf="!editDetails">
<div class="row">
  <div class="col-12 text-right edit-btn mt-3">
    <ng-container *ngIf="!viewMode && showEditButton">
      <button class="back-button button-width-icon-left btn-pos-top-right" (click)="handleEdit()">
        <!-- <img src="../../../../../assets/images/edit.png" alt="" /> -->
        <i class="fa fa-pencil"></i>
        Edit
      </button>
    </ng-container>
  </div>
</div>

<h5 class="labelText mt-2">Statutory Details</h5>
<div class="row row-cols-5">
    <div class="col mb-2 word-wrap">
        <p class="label-light m-0">PF Account Number</p>
        <label class="label-dark wrap-word"> {{
          form16Details?.pfAccountNumber ? form16Details?.pfAccountNumber : "--"
          }}</label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">UAN number</p>
        <label class="label-dark wrap-word">{{
          form16Details?.uanNumber ? form16Details?.uanNumber : "--"
          }}</label>
    </div>
    <div class="col mb-2">
        <p class="label-light m-0">ESI number</p>
        <label class="label-dark wrap-word">{{
          form16Details?.esiNumber ? form16Details?.esiNumber : "--"
          }}</label>
    </div>
</div>


<!-- <div class="row">
    <h5 class="labelText mt-2">Form 16</h5>
    <div class="col-md-12 my-3">
        <h6 class="labelText mt-2">Uploaded Document</h6>
        <p-table [value]="form16Details?.form16DetailsFileUploadDTOList" [resizableColumns]="true" styleClass="p-datatable-gridlines">
            <ng-template pTemplate="header">
                <tr>
                    <th>Type</th>
                    <th>Name</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-loadData>
                <tr>
                  <td>{{loadData?.fileCategory}}</td>
                    <td>{{loadData?.fileName}}</td>
                    <td>
                        <div class="row">
                            <div><i class="fa fa-download pr-2 icn" title="Download" (click)="download(loadData)"></i> </div>
                            <div> <i class="fa fa-trash icn" title="Delete" (click)="deleteDoc(loadData)"></i> </div>
                            </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-loadData>
                <tr>
                  <td [attr.colspan]="3">
                     No records found
                  </td>
                </tr>
              </ng-template>
        </p-table>
    </div>
</div> -->
</div>

<div *ngIf="editDetails" class="edit-form16-details">
    <form [formGroup]="form16DetailsForm" #f="ngForm"
      (ngSubmit)="saveForm16Data()">
      <div class="row mt-2">
      
        <div class="col-3">
          <p class="label-cls text-label">PF Account Number</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (form16DetailsForm.get('pfAccountNumber').touched || submitted) &&
                form16DetailsForm.get('pfAccountNumber').errors?.pattern
            }" pattern="^[0-9]*$" formControlName="pfAccountNumber" placeholder="Enter PF Account Number" />
          <span class="invalid-message" *ngIf="
              (form16DetailsForm.get('pfAccountNumber').touched || submitted) &&
              form16DetailsForm.get('pfAccountNumber').errors?.pattern
            ">
            {{ getGlobalErrorMessages("NUMBER_ONLY") }}
          </span>
          <span class="invalid-message" *ngIf="form16DetailsForm.get('pfAccountNumber').hasError('maxLength')">
            {{ getGlobalErrorMessages("MAXLENGTH") }} 30 Numbers
          </span>
        </div>
        <div class="col-3">
            <p class="label-cls text-label" [class.required]="beneficiaryType==='self'">UAN Number</p>
            <input type="text" class="im-input" [ngClass]="{
                'im-input-error':
                  (form16DetailsForm.get('uanNumber').touched || submitted) &&
                  form16DetailsForm.get('uanNumber').errors?.required
              }" pattern="^[0-9]*$" formControlName="uanNumber" placeholder="Enter UAN Number" />
            <span class="invalid-message" *ngIf="
                (form16DetailsForm.get('uanNumber').touched || submitted) &&
                form16DetailsForm.get('uanNumber').errors?.required
              ">
              {{ getGlobalErrorMessages("REQUIRED") }}
            </span>
            <span class="invalid-message" *ngIf="
                (form16DetailsForm.get('uanNumber').touched || submitted) &&
                form16DetailsForm.get('uanNumber').errors?.pattern
              ">
              {{ getGlobalErrorMessages("NUMBER_ONLY") }}
            </span>
            <span class="invalid-message" *ngIf="form16DetailsForm.get('uanNumber').hasError('maxLength')">
              {{ getGlobalErrorMessages("MAXLENGTH") }} 30 Numbers
            </span>
          </div>
        <div class="col-3">
          <p class="label-cls text-label" [class.required]="beneficiaryType==='self'">ESI Number</p>
          <input type="text" class="im-input" [ngClass]="{
              'im-input-error':
                (form16DetailsForm.get('esiNumber').touched || submitted) &&
                form16DetailsForm.get('esiNumber').errors?.required
            }" pattern="^[0-9-]*$" formControlName="esiNumber" placeholder="Enter ESI Number" />
          <span class="invalid-message" *ngIf="
              (form16DetailsForm.get('esiNumber').touched || submitted) &&
              form16DetailsForm.get('esiNumber').errors?.required
            ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="form16DetailsForm.get('esiNumber').hasError('maxLength')">
            {{ getGlobalErrorMessages("MAXLENGTH") }} 30 Numbers
          </span>
        </div>
       
      </div>
      <!-- <div class="row mt-4">
        <p *ngIf="!viewMode" class="lbl-text-2">Add the Documents</p>
        <app-file-upload style="width: 100%" [configurations]="documentFileUploadConfigurations"></app-file-upload>
      </div> -->
      <div class="row saveBtns">
        <div class="col-12 text-right">
          <button class="back-button d-inline-flex align-items-center pr-3 pl-3 mr-3" *ngIf="form16UpdateProfile"
            (click)="backToTask()">
            <i class="fa fa-chevron-circle-left pr-1" aria-hidden="true"></i>
            Back
          </button>
          <lib-save-as-draft *ngIf="detailsAbout.showDetailFor === 'self'" class="mr-3"
            (onClickSaveAsDraft)="saveAsDraft($event)" [showSaveIcon]="true"
            [formToBeSaved]="form16DetailsForm"></lib-save-as-draft>
          <button type="submit" class="btn btn-success button-width-icon-left mr-3"
            [disabled]="form16DetailsForm.invalid" [ngClass]="{'invalidBtn': form16DetailsForm.invalid }">
            <i class="fa fa-floppy-o"></i>
            Save
          </button>
          <button *ngIf="!editModeVal" type="button" class="back-button button-width-icon-left"
            (click)="clearProfileData(f)">
            <i class="fa fa-times-circle"></i>
            Cancel
          </button>
        </div>
      </div>
    </form>
    </div>